import type { QuestionSetType } from "./QuestionSet";

export type UserPermissionsSettings = Omit<
  UserPermissions,
  "userId" | "companyId" | "hasExplicitAccess" | "availableQuestionSets"
>;
export class UserPermissions {
  constructor(
    public readonly userId: string,
    public readonly companyId: string,
    public readonly hasExplicitAccess: boolean,
    public readonly availableQuestionSets: string[],
    public readonly canExecuteAssessments: boolean,
    public readonly canExportAssessments: boolean,
    public readonly canAccessAllAssessments: boolean,
    public readonly canAccessAssessmentHistory: boolean,
    public readonly canManageCompanies: boolean,
    public readonly canManageCompaniesDestructive: boolean,
    public readonly canManageProjects: boolean,
    public readonly canManageProjectsDestructive: boolean,
    public readonly canManageAssessments: boolean,
    public readonly canManageAssessmentsDestructive: boolean,
    public readonly canAccessCertificates: boolean,
    public readonly canAccessDashboards: boolean,
    public readonly canAccessWeb: boolean,
    public readonly canAccessMobile: boolean,
    public readonly canImport: boolean,
    public readonly canManageUsers: boolean,
    public readonly canManageChecklists: boolean,
    public readonly accessibleQuestionSetTypes: QuestionSetType[],
  ) {}

  static fromJson(json: any): UserPermissions {
    return new UserPermissions(
      json["user_id"],
      json["company_id"],
      json["has_explicit_access"],
      json["available_question_sets"],
      json["can_execute_assessments"],
      json["can_export_assessments"],
      json["can_access_all_assessments"],
      json["can_access_assessment_history"],
      json["can_manage_companies"],
      json["can_manage_companies_destructive"],
      json["can_manage_projects"],
      json["can_manage_projects_destructive"],
      json["can_manage_assessments"],
      json["can_manage_assessments_destructive"],
      json["can_access_certificates"],
      json["can_access_dashboards"],
      json["can_access_web"],
      json["can_access_mobile"],
      json["can_import"],
      json["can_manage_users"],
      json["can_manage_checklists"],
      json["accessible_question_set_types"],
    );
  }
}
